export default __webpack_public_path__ + "static/media/06_photo.c3d268d5.jpg";